import { ISagaModule } from 'redux-dynamic-modules-saga';
import tierPopupSaga from './tierPopupSaga';
import tierManageContentSaga from './tierManageContentSaga';
import tierManageContentReducer from './tierManageContentReducer';
import tierListSaga from './tierListSaga';
import tipJarSaga from './tipJarSaga';
import tierListReducer from './tierListReducer';
import tierPopupReducer from './tierPopupReducer';
import { reduxModuleLoaded, requestTiers } from './actions';
import {
  tierManageContentReduxKey,
  tierListReduxKey,
  tierPopupReduxKey,
} from './constants';

export function getModule(): ISagaModule<{}> {
  return {
    id: 'tierCreator',
    reducerMap: {
      [tierManageContentReduxKey as string]: tierManageContentReducer,
      [tierListReduxKey as string]: tierListReducer,
      [tierPopupReduxKey as string]: tierPopupReducer,
    },
    sagas: [tierPopupSaga, tierManageContentSaga, tierListSaga, tipJarSaga],
    initialActions: [reduxModuleLoaded(), requestTiers()],
    retained: true,
  };
}
